<template>
  <van-list
    v-model:loading="loading"
    class="list"
    :finished="finished"
    loading-text="加载中"
    @load="onLoad"
  >
    <div
      class="common-list"
      v-if="commonList && commonList.length > 0"
    >
      <div
        class="common-item"
        v-for="(item, index) in commonList"
        :key="index"
      >
        <div class="common-item-top">
          <div class="common-item-top-left">
            <van-image
              fit="cover"
              round
              class="common-item-header"
              :src="item.head"
              @click.stop="toHomePage(item.home_page_url)"
            />
            <div class="common-item-left">
              <div class="common-item-name">
                <div
                  class="line-1"
                  style="max-width: 140px"
                >
                  {{ item.nick_name }}
                </div>
                <div v-if="item.is_rewarded">
                  <div class="reward-amount">
                    <div class="redpocket-icon">
                      <img
                        src="@/assets/img/redpocket.png"
                        alt="红包"
                      />
                    </div>
                    <div class="reward-amount-text">
                      已获红包<span
                        v-if="item.reward_amount >= 1"
                        class="reward-amount-text-value"
                        ><span>{{ item.reward_amount }}</span
                        >元</span
                      >
                    </div>
                  </div>
                </div>
                <!-- <van-image
                v-if="item.is_rewarded"
                fit="cover"
                round
                class="common-git"
                :src="require('@/assets/img/common-gif.png')"
              /> -->
              </div>
              <div class="common-item-date">{{ item.create_time }}</div>
            </div>
          </div>
          <div class="common-item-top-right">
            <div
              v-if="!item.is_me"
              class="common-item-submit"
              @click="handleComment(item)"
            >
              回复
            </div>
            <div class="like">
              <van-icon
                @click="handleLike(item)"
                class="like-icon"
                :name="!item.is_like ? 'like-o' : 'like'"
                :color="!item.is_like ? '#767677' : '#FF3333'"
                size="18"
              />
              <div
                class="like-num"
                v-if="item.like_num > 0"
              >
                {{ item.like_num }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="common-item-content"
          @click="handleComment(item)"
        >
          <van-text-ellipsis
            rows="2"
            :content="item.content"
            expand-text="展开"
            collapse-text="收起"
          />
        </div>
        <div
          class="common-item-reply"
          v-if="item.sub_comments && item.sub_comments.length > 0"
        >
          <div
            class="common-item-reply-item"
            v-for="(sub_item, sub_index) in item.sub_comments"
            :key="sub_index"
          >
            <div class="common-item-reply-item-header">
              <div class="common-item-reply-item-header-left">
                <van-image
                  fit="cover"
                  round
                  class="common-item-reply-item-header-img"
                  @click="toHomePage(sub_item.home_page_url)"
                  :src="sub_item.head"
                />
                <span
                  class="common-item-nick-name"
                  @click.stop="toHomePage(sub_item.home_page_url)"
                  ><div
                    class="line-1"
                    style="max-width: 160px"
                  >
                    {{ sub_item.nick_name }}
                  </div>
                  <van-image
                    v-if="sub_item.is_rewarded"
                    fit="cover"
                    round
                    class="common-git"
                    :src="require('@/assets/img/common-gif.png')"
                /></span>
              </div>
              <div class="common-item-reply-right">
                <div
                  v-if="!sub_item.is_me"
                  class="common-item-reply-submit"
                  @click="handleComment(item, sub_item)"
                >
                  回复
                </div>
                <div class="common-item-reply-item-like">
                  <van-icon
                    @click="handleLike(sub_item)"
                    class="common-item-reply-item-like-icon"
                    :name="!sub_item.is_like ? 'like-o' : 'like'"
                    :color="!sub_item.is_like ? '#767677' : '#FF3333'"
                    size="18"
                  />
                  <div
                    class="like-num"
                    v-if="sub_item.like_num > 0"
                  >
                    {{ sub_item.like_num }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="common-item-reply-content"
              @click="handleComment(item, sub_item)"
            >
              <span
                v-if="sub_item.reply_nick_name"
                @click="comment(sub_item)"
              >
                <span class="common-item-text">回复</span>
                <span
                  class="common-item-reply-reply-name"
                  @click.stop="toHomePage(sub_item.reply_home_page_url)"
                  >{{ sub_item.reply_nick_name }}</span
                >：</span
              >{{ sub_item.content }}
              <!-- <van-text-ellipsis
                rows="2"
                :content="sub_item.content"
                expand-text="展开"
                collapse-text="收起"
              /> -->
            </div>
            <div class="common-item-reply-bottom">
              <div class="common-item-reply-date">
                {{ sub_item.create_time }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-cell v-if="commonList && commonList.length == 0">
      <van-empty description="暂无更多评论" />
    </van-cell>
  </van-list>

  <div
    class="mask"
    v-if="isSend"
    @click="handleBlur"
  ></div>
  <div class="footer">
    <div class="chat-footer">
      <div
        class="chat-input"
        :class="[`input${typeCount}`]"
      >
        <van-field
          v-show="!isSend"
          class="search-input"
          rows="1"
          :autosize="{ maxHeight: 60 }"
          type="textarea"
          left-icon="edit"
          placeholder="写评论领随机红包"
          maxlength="200"
          readonly
          @click="toChatPage"
        />
        <van-field
          v-show="isSend"
          ref="fieldRef"
          v-model="value"
          class="search-input scrollable-field"
          rows="1"
          :autosize="{ maxHeight: 60 }"
          label=""
          type="textarea"
          placeholder="下载中山+写评论可领随机红包"
          maxlength="200"
          :show-word-limit="value !== ''"
          label-width="0"
          @input="checkOverflow"
          @focus="handleFocus"
        />
        <div
          v-if="lineCount >= 3"
          class="operate-btn"
          @click="handleChangeExpanded"
        >
          <svg
            v-if="!isExpanded"
            class="icon"
            aria-hidden="true"
            style="width: 20px; height: 20px"
          >
            <use xlink:href="#icon-zhankai"></use>
          </svg>
        </div>
        <!-- <div
          :class="['send-btn', value.trim() !== '' ? 'active' : '']"
          @click="toChat(value.trim())"
        >
          <van-icon name="guide-o" size="22" color="#fff" />
        </div> -->
      </div>
    </div>
    <div
      class="chat-right"
      v-if="isSend"
      :style="!isSend ? 'padding: 0 10px 0 4px;' : 'padding-right: 10px;'"
    >
      <van-button
        v-if="isSend"
        class="submit-btn"
        round
        :loading="loading"
        :disabled="loading"
        loading-text="发送中..."
        @click="toChat(value.trim())"
      >
        发送
      </van-button>
    </div>
    <van-popup
      v-model:show="isExpanded"
      position="bottom"
      :style="{ height: '300px' }"
      @opened="onPopupOpened"
      @closed="onPopupClosed"
    >
      <div class="pop-box">
        <div class="pop-title">
          <svg
            class="icon"
            aria-hidden="true"
            style="width: 20px; height: 20px"
            @click="isExpanded = !isExpanded"
          >
            <use xlink:href="#icon-shousuo"></use>
          </svg>
        </div>
        <div class="pop-content">
          <van-field
            ref="popFieldRef"
            v-model="value"
            label=""
            class="pop-input scrollable-field"
            type="textarea"
            placeholder="写评论"
            maxlength="200"
            :show-word-limit="value !== ''"
            label-width="0"
            @focus="isFocused = true"
            @blur="isFocused = false"
          />
        </div>
        <div class="pop-btm">
          <div
            :class="['pop-btn', value.trim() !== '' ? 'active' : '']"
            @click="toChat()"
          >
            <van-icon
              name="guide-o"
              size="20"
              color="#fff"
            />
          </div>
        </div>
      </div>
    </van-popup>

    <div v-if="isWechat">
      <StatementPopup
        v-model:show="showTurnApp"
        :exinfo="spliceInfo"
      />
    </div>
  </div>
</template>
<script setup>
//引入vant Popup
import {
  Image as VanImage,
  Icon as VanIcon,
  Field as VanField,
  Popup as VanPopup,
  Button as VanButton,
  Empty as VanEmpty,
  TextEllipsis as VanTextEllipsis,
  Cell as VanCell,
  List as VanList
} from "vant";
import { Toast } from "@vant/compat";
import { ref, nextTick, onUnmounted } from "vue";
import Api from "../api";
import { useRoute } from "vue-router";
import StatementPopup from "@/components/StatementPopup.vue";
import { triggerLogin } from "@/utils/triggerLogin";
import Cookies from "js-cookie";
const route = useRoute();
const userAgentString = navigator.userAgent.toLowerCase();

const commonList = ref([]);
const loading = ref(false);
const page = ref(1);
const finished = ref(false);
const onLoad = () => {
  if (route.params.id) {
    getCommentList();
  }
};

const value = ref("");
const isFocused = ref(false); // 输入款是否获取焦点
const isExpanded = ref(false); // 是否展开输入框
const lineCount = ref(1); // 判断输入款显示行数
const typeCount = ref(1); // 判断输入款显示字数
const fieldRef = ref(null); // 输入框
const popFieldRef = ref(null); // 弹出框输入框容器
const textarea = ref(null); // 输入框
const isSend = ref(false);

const isWechat = ref(null);
isWechat.value =
  navigator.userAgent.toLowerCase().indexOf("micromessenger") >= 0;

const isApp = navigator.userAgent.toLowerCase().indexOf("zsrbapp") >= 0;

const showTurnApp = ref(false); // 弹出app下载提示框
const spliceInfo = ref(""); // App跳转信息

const handleFocus = () => {
  isFocused.value = true;
  isSend.value = true;
  disableScroll();
  nextTick(() => {
    if (fieldRef.value) {
      fieldRef.value.focus();
      enableFilderdScroll();
    }
  });
};

// 当 van-popup 打开时绑定事件监听器
const onPopupOpened = () => {
  nextTick(() => {
    enableScroll();
  });
};
const onPopupClosed = () => {
  handleFocus();
};
const handleBlur = () => {
  nextTick(() => {
    lineCount.value = 1;
    isFocused.value = false;
    isSend.value = false;
    enableScroll();
  });
};

//允许filderd 滚动
const enableFilderdScroll = () => {
  // 获取需要允许滚动的元素
  const scrollableElement = document.querySelector(".scrollable-field");
  // 阻止事件冒泡
  scrollableElement.addEventListener(
    "touchmove",
    (event) => {
      event.stopPropagation();
    },
    { passive: false }
  );
};

const handleChangeExpanded = () => {
  isExpanded.value = !isExpanded.value;
};

const disableScroll = () => {
  document.addEventListener("touchmove", preventDefault, {
    passive: false
  });
};

const enableScroll = () => {
  document.removeEventListener("touchmove", preventDefault);
};

const preventDefault = (e) => {
  e.preventDefault();
};

onUnmounted(() => {
  enableScroll();
});

// 监听文字输入
const checkOverflow = async () => {
  textareaResize();
};
// 监听输入框高度变化
const textareaResize = () => {
  textarea.value = fieldRef.value?.$el.querySelector("textarea");
  if (!textarea.value) return;
  lineCount.value = Math.ceil(textarea.value.scrollHeight / 20);
  typeCount.value = lineCount.value > 3 ? 3 : lineCount.value;
};

//获取评论
const getCommentList = () => {
  loading.value = true;
  Api.getCommentList({
    page_size: 20,
    page: page.value,
    id: route.params.id
  }).then((res) => {
    spliceInfo.value = res.data.splice_info;
    if (page.value == 1) {
      commonList.value = [];
    }
    if (res.data.list.length > 0) {
      page.value++;
      commonList.value = commonList.value.concat(res.data.list);
    }
    // 数据全部加载完成
    if (res.data.list.length < 20) {
      finished.value = true;
    }
    loading.value = false;
  });
};
const toChat = () => {
  if (loading.value) return;
  postComment();
};

const currentCommentItem = ref({});
const currentCommentItemId = ref(0);
const currentSubCommentItem = ref({});

//评论点击回复
const handleComment = (item, sub_item = {}) => {
  // 检查点击目标是否是展开/收起按钮
  const isEllipsisClick = event?.target?.classList?.contains(
    "van-text-ellipsis__action"
  );
  if (isEllipsisClick) return;
  if (sub_item && sub_item.id && !sub_item.is_me) {
    currentCommentItem.value = item;
    currentSubCommentItem.value = sub_item;
    currentCommentItemId.value = sub_item.id;
    handleFocus();
    return;
  }
  if (!item.is_me && !sub_item.id) {
    currentCommentItem.value = item;
    currentCommentItemId.value = item.id;
    handleFocus();
  }
};

const handleLike = (item) => {
  const sessionToken = sessionStorage.getItem("session_token");
  if (!sessionToken && isApp) {
    console.log("=======执行这里88888888");
    triggerLogin();
    return;
  }

  Api.postLike(item.id)
    .then((res) => {
      console.log("handleLike", res);
      if (res.code == 1) {
        item.is_like = !item.is_like;
        item.like_num = item.like_num + (!item.is_like ? -1 : 1);
      } else {
        Toast.fail(res.message || "操作失败");
      }
    })
    .catch(() => {
      Toast.fail("操作失败，请重试");
    });
};

const toChatPage = () => {
  currentCommentItem.value = {};
  currentSubCommentItem.value = {};
  currentCommentItemId.value = 0;
  handleFocus();
};

const postComment = () => {
  loading.value = true;
  if (value.value == "") {
    Toast.fail("评论内容不得为空");
    loading.value = false;
    return;
  }

  const sessionToken = sessionStorage.getItem("session_token");
  if (!sessionToken && isApp) {
    console.log("=======执行这里66666");
    triggerLogin();
    return;
  }
  const params = {
    info_id: route.params.id,
    parent_id: currentCommentItemId.value || 0,
    content: value.value
  };
  Api.postComment(params)
    .then((res) => {
      console.log("返回", res.data);
      if (res.code == 1) {
        // Toast.success(res.message)
        value.value = "";
        isExpanded.value = false;
        textareaResize();
        loading.value = false;
        showTurnApp.value = true;
        if (currentCommentItemId.value != 0) {
          if (currentSubCommentItem.value.id) {
            // 查找item.sub_comment是否存在currentSubCommentItem.value.id
            commonList.value
              .find((item) => item.id == currentCommentItem.value.id)
              .sub_comments.unshift({
                ...res.data,
                is_me: true
              });
          } else {
            commonList.value
              .find((item) => item.id == currentCommentItemId.value)
              .sub_comments.unshift({
                ...res.data,
                is_me: true
              });
          }
        } else {
          commonList.value.unshift({
            ...res.data,
            is_me: true
          });
        }
        currentCommentItemId.value = 0;
        handleBuried();
        console.log("评论成功", commonList.value);
      } else {
        console.log("评论失败", res);
        Toast.fail(res.message);
        loading.value = false;
        showTurnApp.value = false;
      }
      handleBlur();
    })
    .catch(() => {
      loading.value = false;
      showTurnApp.value = false;
      handleBlur();
    });
};
//埋点
const handleBuried = () => {
  // 南方智媒云数据上报
  window.TrackKit.zmyAdapter.commentArticle({
    article_id: route.params.id
  });
};

const toHomePage = (url) => {
  if (url) {
    if (userAgentString.indexOf("zsrbapp") >= 0) {
      window.ZsrbApp.call("viewInfo", {
        type: "",
        id: "",
        title: "",
        img: "",
        summary: "",
        url,
        isComment: 0,
        commentCount: 0
      });
    } else if (userAgentString.indexOf("micromessenger") >= 0) {
      window.open(url, "_blank");
    }
  }
};
</script>
<style lang="scss" scoped>
@use "@/style/common.scss" as common;
.common-list {
  padding: 10px 22px 80px;
  .common-item {
    padding: 12px 0;
    border-bottom: 1px solid #e4e7ed;
    .common-item-top {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
      .common-item-top-left {
        display: flex;
        align-items: center;
      }
      .common-item-top-right {
        display: flex;
        align-items: center;
        .common-item-submit {
          color: #101010;
          font-size: 14px;
          height: 20px;
          line-height: 22px;
          padding: 0 10px;
          background: #f8f8f8;
          border-radius: 9px;
          margin-right: 10px;
        }
      }
      .common-item-header {
        width: 25px;
        height: 25px;
        margin-right: 9px;
      }
      .common-item-left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .common-item-date {
          color: #c0c4cc;
          font-size: 12px;
        }
      }
      .common-item-name {
        color: #6d6d6d;
        font-size: 14px;
        max-width: 220px;
        display: flex;
        align-items: center;
        gap: 12px;
      }
      .common-git {
        min-width: 57px;
        width: 57px;
        height: 20px;
      }
      .like {
        display: flex;
        align-items: center;
        .like-num {
          margin-left: 7px;
          color: #2a2a2a;
          font-size: 12px;
        }
      }
    }
    .common-item-content {
      color: #2a2a2a;
      font-size: 16px;
      text-align: left;
      line-height: 1.5;
      padding-left: 30px;
    }
    .common-item-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .common-item-reply {
      // background-color: #f8f8f8;
      // border-radius: 8pt;
      // padding: 12px 14px;
      // margin-top: 13px;
      .common-item-reply-item {
        padding: 12px 0 0 30px;
        // border-bottom: 1px solid #e4e7ed;
        .common-item-reply-item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;
          .common-item-reply-item-header-left {
            display: flex;
            align-items: center;
            .common-item-reply-item-header-img {
              width: 20px;
              height: 20px;
              margin-right: 9px;
            }
            .common-item-reply-item-header-name {
              color: #6d6d6d;
              font-size: 14px;
            }

            .common-item-nick-name {
              color: #6d6d6d;
              font-size: 14px;
            }
          }
          .common-item-reply-item-like {
            display: flex;
            align-items: center;
            .like-num {
              margin-left: 7px;
              color: #2a2a2a;
              font-size: 12px;
            }
          }
        }
        .common-item-reply-content {
          color: #2a2a2a;
          font-size: 16px;
          text-align: left;
          margin-bottom: 5px;
          line-height: 1.5;
          padding-left: 26px;
          .common-item-reply-reply-name {
            color: #6d6d6d;
            font-size: 14px;
          }
        }
        .common-item-text {
          color: #1d89ff;
          padding-right: 5px;
        }
        .common-item-reply-right {
          display: flex;
          .common-item-reply-item-like {
            display: flex;
            align-items: center;
            margin-left: 8px;
            .like-num {
              margin-left: 7px;
              color: #2a2a2a;
              font-size: 12px;
            }
          }
          .common-item-reply-submit {
            color: #101010;
            font-size: 14px;
            height: 20px;
            line-height: 22px;
            padding: 0 10px;
            background: #f8f8f8;
            border-radius: 9px;
            white-space: nowrap;
          }
        }
        .common-item-reply-bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .common-item-reply-date {
            color: #c0c4cc;
            font-size: 12px;
          }
        }
      }
      .common-item-reply-item:last-child {
        border-bottom: none;
      }
    }
  }
  .common-item:last-child {
    border-bottom: none;
  }
  .common-item:last-of-type {
    border-bottom: none;
  }
}
.mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(16, 16, 16, 0.4);
  z-index: 100;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 101;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.05);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chat-footer {
  position: relative;
  text-align: center;
  width: 100%;
  height: auto;
  bottom: 0;
  // width: 100vw;
  border-radius: 16px;
  .new-chat-btn {
    background-color: #6595fd;
    color: #fff;
    display: inline-flex;
    padding: 3px 10px;
    border-radius: 8px;
    font-size: 14px;
    align-items: center;
  }
  .u-tips {
    font-size: 12px;
    text-align: center;
    padding-bottom: 10px;
    color: #797979;
  }
}
.chat-input {
  position: relative;
  margin: 10px 10px;
  border-radius: 50px;
  overflow: hidden;
  padding-right: 30px;
  background: rgba(208, 208, 208, 0.3);
  .send-btn {
    position: absolute;
    right: 5px;
    top: 50%;
    margin-top: -14px;
    height: 28px;
    width: 28px;
    background: #c7c7c7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .send-btn.active {
    background: #6172f9;
  }
  .search-input {
    background: rgba(0, 0, 0, 0);
    color: #000;
    padding: 3px 14px;
    overflow: visible;
    :deep(.van-field__control) {
      color: #000;
      line-height: 26px;
      font-size: 14px;
    }
    :deep(.van-field__word-limit) {
      margin-right: -40px;
    }
    :deep(.van-field__left-icon) {
      color: #9e9e9e;
    }
    ::placeholder {
      color: #c0c4cc;
    }
  }
}

.chat-right {
  text-align: center;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .submit-btn {
    border-radius: 19px;
    background: linear-gradient(
      97deg,
      rgba(255, 58, 75, 1) 14%,
      rgba(255, 123, 83, 1) 95%
    );
    height: 34px;
    width: 78px;
    font-size: 16px;
    color: #fff;
    font-weight: 700;
    white-space: nowrap;
  }
}

.input1 {
  border-radius: 50px;
}
.input2 {
  border-radius: 10px;
}
.input3 {
  border-radius: 10px;
  .send-btn {
    top: auto;
    bottom: 8px;
    margin-top: 0;
  }
  .operate-btn {
    position: absolute;
    top: 8px;
    right: 18px;
  }
}
.input4 {
  padding: 30px 5px 30px !important;
  .send-btn {
    top: auto;
    bottom: 5px;
    margin-top: 0;
  }
  .operate-btn {
    position: absolute;
    top: 10px;
    right: 12px;
  }
}

.pop-box {
  display: flex;
  flex-direction: column;
  height: 100%;
  .pop-title {
    padding: 16px 16px 0;
    display: flex;
    justify-content: flex-end;
  }
  .pop-content {
    flex: 1;
  }
  .pop-btm {
    padding: 0px 16px 16px;
    display: flex;
    justify-content: flex-end;
  }
  .pop-btn {
    height: 28px;
    width: 28px;
    background: #c7c7c7;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
  .pop-btn.active {
    background: #6172f9;
  }
}

.pop-input {
  height: 100%;
  .van-field__body {
    height: 100%;
  }
  .van-field__control {
    line-height: 20px;
    height: 100%;
  }
  :deep(.van-field__body) {
    height: 90%;
  }
  :deep(textarea) {
    height: 100%;
  }
}
</style>
